/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Facts_Functions_LabelInputs */

const en_gc_resources_facts_functions_label = /** @type {(inputs: Gc_Resources_Facts_Functions_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`functions`)
};

const zh_gc_resources_facts_functions_label = /** @type {(inputs: Gc_Resources_Facts_Functions_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`函数`)
};

/**
* | output |
* | --- |
* | "functions" |
*
* @param {Gc_Resources_Facts_Functions_LabelInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_facts_functions_label = /** @type {((inputs?: Gc_Resources_Facts_Functions_LabelInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Facts_Functions_LabelInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_facts_functions_label(inputs)
	return zh_gc_resources_facts_functions_label(inputs)
});
export { gc_resources_facts_functions_label as "gc.resources.facts.functions.label" }